import React from 'react'
import { Box, Typography, Button } from '@mui/material'
import Navbar from "../Header/Navbar"
import bg from './bgCar.png'
import JoinUs from './JoinUs'
import FoodDelivery from './FoodDelivery'
import DiscountDriver from './DiscountDriver'
import DeliverWay from './DeliverWay'
import Footer from '../Footer/Footer'
import { Link } from 'react-router-dom'

const BecomeDriver = () => {
    return (
        <>

            <Box>
                <Navbar />
                <Box sx={{ mt: '140px' }}>

                    <Box component="container" sx={{
                        display: 'flex',
                        flexDirection: { lg: 'row', md: 'row', sm: 'row', xs: 'column' },
                        padding: '30px',
                        alignItems: 'start'
                    }}>
                        <Box sx={{ width: { lg: '50%', md: '50%', sm: '60%', xs: '100%' } }}>
                            <Typography variant="h4" sx={{
                                fontWeight: 600,
                                fontSize: { lg: '56px', md: '50px', sm: '45px', xs: '35px' }
                            }}>
                                Come on, start your journey with us !
                            </Typography>
                            <Box sx={{ mt: '15px', mb: '30px' }}>
                                <Link to="/registerdriver">
                                    <Button variant="contained">Become a driver</Button>
                                </Link>
                            </Box>
                        </Box>
                        <Box sx={{ width: { lg: '50%', md: '50%', sm: '40%', xs: '100%' } }}>
                            <Typography variant="body2" sx={{
                                fontWeight: 400,
                                fontSize: "15px"
                            }}>
                                Instead of traditional food delivery jobs where the hours aren’t flexible, try being your own boss with EatCoast. Het Paid to deliver on your schedule using the food delivery apps most downloaded by customers
                            </Typography>
                        </Box>
                    </Box>

                    <Box>
                        <img src={bg} width="100%" />
                    </Box>
                    <Box>
                        <JoinUs />
                    </Box>
                    <Box>
                        <FoodDelivery />
                    </Box>
                    <Box>
                        <DiscountDriver />
                    </Box>
                    <Box>
                        <DeliverWay />
                    </Box>
                    <Box sx={{ mt: '100px' }}>
                        <Footer />
                    </Box>
                </Box>
            </Box>
        </>
    )
}

export default BecomeDriver
